import { useCallback, useEffect, useRef } from "react";

export default function useAbortController() {
  const controllerRef = useRef<AbortController | null>(null);

  const resetController = useCallback(function () {
    controllerRef?.current?.abort();

    const controller = new AbortController();
    controllerRef.current = controller;

    return controller;
  }, []);

  useEffect(() => {
    return function () {
      controllerRef?.current?.abort();
    };
  }, []);

  return { controllerRef, resetController };
}
